import { cn } from "@/lib/cn";

const COLORS = [
  "bg-coral-100 text-coral-700",
  "bg-sky-100 text-sky-700",
  "bg-amber-100 text-amber-700",
  "bg-emerald-100 text-emerald-700",
  "bg-violet-100 text-violet-700",
];

function initialsColor(name: string) {
  let hash = 0;
  for (let i = 0; i < name.length; i++) hash = (hash * 31 + name.charCodeAt(i)) | 0;
  return COLORS[Math.abs(hash) % COLORS.length];
}

interface TestimonialCardProps {
  quote: string;
  author: string;
  company: string;
  className?: string;
}

export function TestimonialCard({ quote, author, company, className }: TestimonialCardProps) {
  const initials = author
    .split(" ")
    .map((w) => w[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();

  return (
    <blockquote
      className={cn(
        "flex flex-col justify-between rounded-xl border border-border bg-card p-6 shadow-card",
        className,
      )}
    >
      <p className="text-lg leading-relaxed text-foreground">"{quote}"</p>
      <footer className="mt-4 flex items-center gap-3">
        <span
          aria-hidden="true"
          className={cn(
            "inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-xs font-bold",
            initialsColor(author),
          )}
        >
          {initials}
        </span>
        <span className="text-sm text-muted-foreground">
          {author}, {company}
        </span>
      </footer>
    </blockquote>
  );
}
